<div class="container">
  <h1>Terms and Conditions</h1>
  <p>Last updated: February 2025</p>

  <h2>1. Introduction</h2>
  <p>
    Welcome to Hyperdrive. By using our app and services, you agree to the
    following terms and conditions.
  </p>

  <h2>2. User Responsibilities</h2>
  <p>
    Users must provide accurate personal information and comply with local laws
    while using our services.
  </p>

  <h2>3. Booking and Payments</h2>
  <p>
    All ride bookings are subject to availability. Payments are processed
    securely through our app.
  </p>

  <h2>4. Cancellations and Refunds</h2>
  <p>
    Users may cancel rides, but cancellation fees may apply based on the timing
    of the cancellation.
  </p>

  <h2>5. Liability</h2>
  <p>
    Hyperdrive is not responsible for any loss or damages resulting from service
    disruptions.
  </p>

  <h2>6. Updates to Terms</h2>
  <p>
    We may update these terms from time to time. Continued use of our service
    implies agreement to the revised terms.
  </p>
</div>
